<div class="scad-read-tab">
  <div class="scad-read-tab__tab-item-area">
    <div class="scad-title__semi-bold mb-4">Read</div>

    <div class="scad-read-tab__tab-item">
      <div class="scad-read-tab__tab" [class.active]="selectedTab === 'tab1'" (click)="selectTab('tab1')"> Configuration
      </div>
      <div class="scad-read-tab__tab" [class.active]="selectedTab === 'tab2'" (click)="selectTab('tab2')"> Preview
      </div>
      <div class="scad-read-tab__tab" [class.active]="selectedTab === 'tab3'" (click)="selectTab('tab3')"> Logs
      </div>
    </div>

  </div>

  <div class="scad-read-tab__tab-content">
    <ng-container *ngIf="selectedTab === 'tab1'">
      <!-- Content for Tab 1 -->
      <div class="scad-read-tab__tab-content-body">
        <div class="scad-read-tab__tab-content-head">
          <div class="scad-read-tab__tab-content-sub-content">
            <div class="scad-title__sm-label">
              Completed on : <span> 12/09/2023 9:00 am</span>
            </div>
            <div class="scad-title__sm-label d-flex line2">
              Sync time :
              <span class="d-flex"> 290 ms
              <span class="d-flex mx-2" ><img src="/assets/images/svg/tick-black.svg" alt="" /></span>
              </span>
            </div>
          </div>
          <button class="scad-btn scad-btn--primary">Test Connection</button>
        </div>

        <div class="scad-form">
          <div class="scad-input pt-4">
            <div class="scad-title__sm-label mb-3">Component name</div>
            <input type="text" class="scad-input-half" placeholder="Enter here" />
          </div>
          <div class="scad-input pt-4">
            <div class="scad-title__sm-label mb-3">Component description (optional)</div>
            <input type="text" class="scad-input-half" placeholder="Enter here" />
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="selectedTab === 'tab2'">
      <!-- Content for Tab 2 -->
      <p>Content for Tab 2 goes here.</p>
    </ng-container>
    <ng-container *ngIf="selectedTab === 'tab3'">
      <!-- Content for Tab 2 -->
      <p>Content for Tab 2 goes here.</p>
    </ng-container>
  </div>
</div>
